import { render, staticRenderFns } from "./VisualizationToolJS.vue?vue&type=template&id=3bd04018&scoped=true&"
import script from "./VisualizationToolJS.vue?vue&type=script&lang=js&"
export * from "./VisualizationToolJS.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bd04018",
  null
  
)

export default component.exports